import { Component, OnInit } from '@angular/core';
import { RecentactivitiesdashboardService } from '../recentactivitiesdashboard/recentactivitiesdashboard.service'
import { ToastrService } from 'ngx-toastr';
import { ProductService } from '../../Master/product/product.service';
import { Product } from '../../Master/product/product'
import { async } from 'rxjs/internal/scheduler/async';
import { RequestconfigService } from '../../configuration/requestconfig/requestconfig.service';
import { saveFile, saveAs } from 'file-saver';
import { FormrenderService } from '../../formrender/formrender.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormdashboardService } from '../formdashboard/formdashboard.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from "ngx-spinner";
import { LocalService } from '../../local.service';
import {encryptdecrypt} from '../../encryptdecrypt';

import { __await } from 'tslib';
@Component({
  selector: 'app-recentactivitiesdashboard',
  templateUrl: './recentactivitiesdashboard.component.html',
  styleUrls: ['./recentactivitiesdashboard.component.css']
})
export class RecentactivitiesdashboardComponent implements OnInit {
  sendMenuId: number = 4;
  sendPageName: string = 'Recent Activities';
  conversionrequest: boolean = true; courtagoopinionrequest = false; prodformar: any = []; prodformat: string = ''; outputformatstr: string = '';
  outputformatstrarr: any = []
  researchgrouprequest: boolean = false; informationrequest: boolean = false; internetdownloadrequest: boolean = true;
  docrecentactivitiesList: any = []; docDetails: any = []; selectedFormName: string = ''; selectedDocumentId: number = 0;
  headers: any = []; _masterList: any; _masterValues: any = []; currentDocument: any = []; fileDownloadList: any = []; selectedDatabaseId: string = ''; selectedFormconfigId: number = 0;
  activityType: string = '';
  //public userid = localStorage.getItem('userid');
  public userid = this.localService.getJsonValue('userid')
  reqindex: number; docindex: number = 0
  selectedDatabasename: string = '';
  requestCount: number = 0;
  documentCount: number = 0;
  searchTextRequest: string = '';
  requestList: any[] = [];
  p: number = 1; itemsPerPage: number = 10; currentRequest: any
  q: number = 1;
  activatedTab: string = 'documenttab';
  enc=new encryptdecrypt();
  constructor(private recentactivityService: RecentactivitiesdashboardService,
    private requestConfigService: RequestconfigService,
    private toastr: ToastrService, private productService: ProductService, private route: ActivatedRoute,
    private formdashboardservice: FormdashboardService,
    private sanitizer: DomSanitizer, private router: Router, private SpinnerService: NgxSpinnerService,
    private formRenderService: FormrenderService, private localService: LocalService
) {
    this.route.queryParams.subscribe(params => {
      this.activityType = params['recentactivities'];
    });

  }
 
  ngOnInit() {
    
    this.getRecentDocumentDetails();
    //this.getAllRequestcount();
    //this.getAllRecentActivitiesDocumentCount()
    this.getAllRequests();
    this.LoadAllMasterDetails();
   
  }

  getAllRequests() {
    let spdata: string;
    this.SpinnerService.show();
    spdata = this.itemsPerPage + '*' + this.p + '*' + this.userid + '*' + this.searchTextRequest.trim();
    let spdatacount: string;

    spdatacount = this.userid + '*' + this.searchTextRequest.trim()
    this.recentactivityService.getAllRequestsCount(spdatacount).toPromise().then(res => {
      this.requestCount = JSON.parse(res[0].j)[0].count;
      if (this.requestCount > 0) {
        this.recentactivityService.getAllRequests(spdata).toPromise().then(res => {
          if (res != undefined && res != null && res[0].j != null) {
            var allData = JSON.parse(res[0].j);
            this.requestList = allData;
          }
          else {
            this.requestList = [];
          }
          this.reqindex = 0;
          this.showRequestData(this.requestList[this.reqindex], this.reqindex);
          this.SpinnerService.hide();
        },
          err => {
            this.toastr.error('Not able to get RequestDetails')
            this.SpinnerService.hide();
          });
      }
      else {
        this.SpinnerService.hide();
        this.requestList = [];
        this.currentRequest = [];
      }
    },
      err => {
        this.SpinnerService.show();
        this.toastr.error('Not able to get RequestDetails count')
      });
  };

  changeitemsperpage(eve) {
    //this.SpinnerService.show();
    this.itemsPerPage = +eve.currentTarget.value;
    this.p = 1;
    this.q = 1;
    this.getRecentDocumentDetails();
    this.getAllRequests();
    // this.SpinnerService.hide();
  }

  getPageReq(page: number) {

    this.p = page;

    this.getAllRequests();
  }

  getPageforDoc(page: number) {
    this.q = page;
    this.getRecentDocumentDetails();
  }

  //getAllRequestcount() {

  //  this.recentactivityService.getAllRequestsCount(+this.userid).subscribe(res => {

  //    this.requestCount = JSON.parse(res[0].j)[0].count
  //    //this.requestCount = this.requestCount[0].count

  //    // this.products = this.getproducts(this.requestList)
  //  },
  //    err => {
  //      this.toastr.error('Not able to get RequestDetails count')
  //    })

  //}

  //getAllRecentActivitiesDocumentCount() {
  //  let userData: string;
  //  userData = this.userid + '*' + 'getcount';
  //  this.recentactivityService.getdocumentRecentActivitiesCount(userData).subscribe(res => {
  //    this.documentCount = JSON.parse(res[0].sprecentactivitiesdocument).count
  //   // this.documentCount = this.documentCount[0].count

  //    // this.products = this.getproducts(this.requestList)
  //  },
  //    err => {
  //      this.toastr.error('Not able to get documentDetails count')
  //    })

  //}

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [month, day, year].join('/');
  }

  //showDocumentData(doc, ind) {
  //  let _documentList: any = [];
  //  this.docDetails = [];
  //  this.headers = [];
  //  this.fileDownloadList = [];
  //  this.docindex = ind;
  //  this.selectedFormName = doc.formname;
  //  this.selectedDatabaseId = doc.databaseid;
  //  this.selectedDatabasename = doc.database;
  //  this.selectedFormconfigId = doc.formconfigid;

  //  this.selectedDocumentId = doc.documentid;

  //  var formconfigdetails = this.selectedFormconfigId + '*' + this.selectedDocumentId;
  //  //get the form document details
  //  this.formdashboardservice.getSelectedDocumentDetails(formconfigdetails).subscribe(
  //    (res) => {
  //      //console.log(res);
  //      if (res != undefined && res != null && res.length != 0) {
  //        var s = JSON.parse(res[0].j);
  //        if (s.length != 0) {
  //          this.headers = Object.keys(s[0]);
  //          this.currentDocument = s[0];
  //        }

  //      }
  //    });

  //}

  showDocumentData(doc, ind) {
    let _documentList: any = [];
    this.docDetails = [];
    this.headers = [];
    this.fileDownloadList = [];
    this.docindex = ind;
    this.selectedFormName = doc.formname;
    this.selectedDatabaseId = doc.databaseid;
    this.selectedDatabasename = doc.database;
    this.selectedFormconfigId = doc.formconfigid;
    this.selectedDocumentId = doc.documentid;
    var formconfigdetails = this.selectedFormconfigId + '*' + this.selectedDocumentId;
    //get the form document details
    this.formdashboardservice.getSelectedDocumentDetails(formconfigdetails).subscribe(
      (res) => {

        if (res != undefined && res != null && res.length != 0) {
          var s = JSON.parse(res[0].j);
          if (s.length != 0) {
            this.headers = Object.keys(s[0]);
            this.currentDocument = s[0];
            //added thie line for files
            this.formRenderService.getFormRenderDocumentDetails(formconfigdetails).subscribe(
              (result) => {
                if (result != undefined && result != null && result.length != 0 && (JSON.parse(result[0].j) != null)) {
                  var list = JSON.parse(result[0].j);
                  var _headertmp = Object.keys(list[0]);
                  if (_headertmp.length != 0) {
                    _headertmp.forEach(e => {
                      if (e.toLowerCase().startsWith('file')) {
                        if (!e.toLowerCase().endsWith('size')) {
                          var s = list[0][e].split(';');
                          if (s.length != 0) {
                            for (var n = 0; n < s.length; n++) {
                              if (s[n] != '') {
                                this.fileDownloadList.push({ filename: s[n] })
                              }
                            }
                          }
                        }
                      }
                    })
                  }
                }
              });

          }

        }
      });

  }

  getMasterText(masterValues, selectedValues, tablename) {
    var selectedText = '';
    if (selectedValues.length == 1) {
      if ((this._masterValues != undefined) && (this._masterValues.length != 0)) {
        this._masterValues.forEach(k => {
          var fieldName = tablename.toLowerCase() + 'id';
          var fieldValue = tablename.toLowerCase();
          if (k[fieldName] == selectedValues[0].selected) {
            selectedText = k[fieldValue];
          }
        });
      }
    }
    else {
      selectedValues.forEach(a => {
        if ((a.selected != undefined) && (a.selected != null)) {
          if ((this._masterValues != undefined) && (this._masterValues.length != 0)) {
            this._masterValues.forEach(k => {
              var fieldName = tablename.toLowerCase() + 'id';
              var fieldValue = tablename.toLowerCase();
              if (k[fieldName] == a.selected) {
                selectedText = k[fieldValue] + ',' + selectedText;
              }
            });
          }
        }
      });
      selectedText = selectedText.slice(0, -1);
    }
    return selectedText;
  }

  LoadAllMasterDetails() {
    this.formdashboardservice.getAllMasterDetails().subscribe(res => {
      this._masterList = res;
      
    });
  }

  removeSpecialCharacters(text) {
    var cleanedTxt = text.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, '');
    return cleanedTxt;
  }

  validateFields(item, html) {
    if ((html != undefined && html.length != 0 && html != null) && (item != undefined && item != null && item.length != 0)) {
      var keys = Object.keys(item);
      for (var n = 0; n < keys.length; n++) {
        var txt = this.removeSpecialCharacters(keys[n]);
        keys[n] = txt;
        var s = html.filter(e => e.formcontrolname.toLowerCase() == keys[n])
        if ((s == undefined) || (s.length == 0)) {
          if ((keys[n] != 'Document ID') && (keys[n] != 'Created By') && (keys[n] != 'Created On') && (keys[n] != 'Form Name')) {
            // console.log(keys[n]);
            delete item[keys[n]];
            //n = n + 1;
          }
        }
      }

    }
  }

  getRecentDocumentDetails() {
    this.SpinnerService.show();
    this.docrecentactivitiesList = [];
    let userData: string;
    userData = this.userid + '*' + 'getAll*' + this.searchTextRequest.trim();
    let userDataCount: string;
    userDataCount = this.userid + '*' + 'getcount*' + this.searchTextRequest.trim();
    this.recentactivityService.getdocumentRecentActivitiesCount(userDataCount).toPromise().then(res => {
      this.documentCount = JSON.parse(res[0].sprecentactivitiesdocument).count;
      if (this.documentCount > 0) {
        this.recentactivityService.getdocumentRecentActivities(userData, this.itemsPerPage, this.q).toPromise().then(res => {
          if (res != undefined && res != null && res.length != 0) {
            res.forEach(i => {
              var s = JSON.parse(i.sprecentactivitiesdocument);
              if (s != undefined && s != null && s.length != 0) {
                this.docrecentactivitiesList.push(
                  {
                    formname: s.formconfigname,
                    firstname: s.firstname,
                    createdon: s.createdon,
                    documentid: s.documentid,
                    database: s.database,
                    formconfigid: s.formconfigid,
                    databaseid: s.databaseid,
                    modifiedon: s.modifiedon,
                    doctitle: s.formconfigname + ' - ' + s.documentid
                  });
              }

            });
            //this.q = 1
          }
          if (this.docrecentactivitiesList.length > 0) {
            this.showDocumentData(this.docrecentactivitiesList[0], this.docindex);
            this.SpinnerService.hide();
          }
          else {

            this.currentDocument = [];
          }
          this.SpinnerService.hide()
        });
      }
      else {
        this.docrecentactivitiesList = [];
        this.currentDocument = [];
        this.SpinnerService.hide()
      }
    },
      err => {
        this.toastr.error('Not able to get documentDetails count')
      })


  }

  //fileDownload(filename) {

  //  this.requestConfigService.DownloadFile(this.selectedDocumentId, this.selectedDatabasename, this.selectedFormconfigId, filename).subscribe(res => {
  //    var content = res.file;
  //    let objectURL = 'data:application/octet-stream;base64,' + res.file;
  //    saveAs(objectURL, filename);
  //  });

  //}

  fileDownload(filename) {
    this.SpinnerService.show();
    let fileData: any = [];
    fileData.push({
      'documentId': this.selectedDocumentId, 'dbName': this.selectedDatabasename, 'formConfigId': this.selectedFormconfigId, 'fileName': filename
    })
    this.requestConfigService.DownloadFormFile(fileData[0]).subscribe(res => {
      var content = res.body.file;
      let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
      saveAs(objectURL, filename);
      this.SpinnerService.hide();
    },
      error => {
        this.toastr.error('File not found');
        this.SpinnerService.hide();
      });

    //this.requestConfigService.DownloadFile(this.selectedDocumentId, this.selectedDatabasename, this.selectedFormconfigId, filename).subscribe(res => {
    //  var content = res.file;
    //  let objectURL = 'data:application/octet-stream;base64,' + res.file;
    //  saveAs(objectURL, filename);
    //});

  }

  showRequestData(request, i) {
    this.recentactivityService.getRequestById(request.requestid, request.requesttypeid).subscribe(res => {
      this.currentRequest = res; this.prodformar = []; this.prodformat = '';
      this.currentRequest = JSON.parse(this.currentRequest[0].j);
      this.currentRequest = this.currentRequest[0];
      if (this.currentRequest.productformat) {
        this.prodformar = this.currentRequest.productformat
        this.prodformat = '';
        this.prodformar.forEach((d) => {
          if (d.value == 1) {
            if (this.prodformat == '')

              this.prodformat = d.name;
            else
              this.prodformat = this.prodformat + ',' + d.name;

          }
        });
      }
     

      if (this.currentRequest.requesttype === 'courtagoopinionrequest') {
        this.conversionrequest = false;
        this.courtagoopinionrequest = true;
        this.researchgrouprequest = false; this.internetdownloadrequest = false; this.informationrequest = false;
      }
      if (this.currentRequest.requesttype === 'researchgrouprequest') {
        this.conversionrequest = false;
        this.courtagoopinionrequest = false;
        this.researchgrouprequest = true; this.internetdownloadrequest = false; this.informationrequest = false;
      }
      if (this.currentRequest.requesttype === 'informationrequest') {
        this.conversionrequest = false;
        this.courtagoopinionrequest = false;
        this.researchgrouprequest = false; this.internetdownloadrequest = false; this.informationrequest = true;
      }
      if (this.currentRequest.requesttype === 'internetdownloadrequest') {
        this.conversionrequest = false;
        this.courtagoopinionrequest = false;
        this.researchgrouprequest = false; this.internetdownloadrequest = true; this.informationrequest = false;
      }
      if (this.currentRequest.requesttype === 'conversionrequest') {
        this.conversionrequest = true;
        this.outputformatstr = '';
        if (this.currentRequest.outputfiles) {
          this.outputformatstrarr = this.currentRequest.outputfiles
          //var prodformat = '';
          this.outputformatstrarr.forEach((d) => {
            if (d.value == 1) {
              if (this.outputformatstr == '')

                this.outputformatstr = d.name;
              else
                this.outputformatstr = this.outputformatstr + ',' + d.name;

            }
          });
        }

        this.courtagoopinionrequest = false;
        this.researchgrouprequest = false; this.internetdownloadrequest = false; this.informationrequest = false;
      }
      this.reqindex = i
    }, error => { this.toastr.error('') })

  }

  //fileDownloadrequest(request, type) {

  //  this.requestConfigService.DownloadFileRequest(request.database, request.requesttype, request.courtagoopinionrequestid, type, request.finalupload).subscribe(res => {
  //    var content = res.file;
  //    let objectURL = 'data:application/octet-stream;base64,' + res.file;
  //    saveAs(objectURL, request.finalupload);
  //  });
  //}

  fileDownloadrequest(request, type) {
    this.SpinnerService.show();
    //added from this line
    var requestid = 0;
    if (request.requesttypeid == 1)
      requestid = request.courtagoopinionrequestid;
    else if (request.requesttypeid == 2)
      requestid = request.researchgrouprequestid;
    else if (request.requesttypeid == 3)
      requestid = request.informationrequestid;
    else if (request.requesttypeid == 4)
      requestid = request.internetdownloadrequestid;
    else
      requestid = request.conversionrequestid;
    //added ends

    let requestData: any = [];
    requestData.push({
      'requesttype': request.requesttype, 'dbname': request.database, 'requestid': requestid, 'fileName': request.finalupload
    })

    this.requestConfigService.DownloadFileRequestWithSpecialCharacters(requestData[0]).subscribe(res => {
      var content = res.body.file;
      let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
      saveAs(objectURL, request.finalupload);
      this.SpinnerService.hide();
    },
      error => {
        this.toastr.error('File not found');
        this.SpinnerService.hide();
      });

    //this.requestConfigService.DownloadFileRequest(request.database, request.requesttype, request.courtagoopinionrequestid, type, request.finalupload).subscribe(res => {
    //  var content = res.file;
    //  let objectURL = 'data:application/octet-stream;base64,' + res.file;
    //  saveAs(objectURL, request.finalupload);
    //});
  }

  viewrequest(request) {
    let a = request.requestid + '*' + request.requesttypeid
    this.router.navigate(['/home/requestconfig'], { queryParams: { 
      requestid: this.enc.encryptUsingAES256(request.requestid.toString()), 
      requesttypeid: this.enc.encryptUsingAES256(request.requesttypeid.toString()), 
      redirectmode: this.enc.encryptUsingAES256('viewrequest') } })
  }

  //method to open form render
  openFormRender() {
    this.router.navigate(['/home/formrender'],
      {
        queryParams: {
           'formDB': this.enc.encryptUsingAES256(this.selectedDatabaseId.toString()), 
           'data': this.enc.encryptUsingAES256(this.selectedDocumentId.toString()), 
           'formConfigId': this.enc.encryptUsingAES256(this.selectedFormconfigId.toString()), 
           'mode': this.enc.encryptUsingAES256('View') }
      });


  }

  activeTab(event) {
    this.searchTextRequest = '';
    if (event.activeId === 'documenttab') {
      this.activatedTab = 'requesttab';
      this.getAllRequests();
    }
    if (event.activeId === 'requesttab') {
      this.activatedTab = 'documenttab';
      this.getRecentDocumentDetails();
    }
  }

  keypress(eve) {
    if (eve.keyCode == 13) {
      this.recentActivitiesserversideSearch();
    }
  }

  async recentActivitiesserversideSearch() {

    if (this.activatedTab === 'requesttab') {
      this.p = 1;
      //await this.getAllRequestcount();
      await this.getAllRequests();
    }
    else if (this.activatedTab === 'documenttab') {
      this.q = 1
      //await this.getAllRecentActivitiesDocumentCount();
      await this.getRecentDocumentDetails();
    }

  }
}
